import { Page } from "@components/layout/Page";
import { Checklist, FormBlock, TextBlock } from "@components/product/Blocks";
import { ProductHero } from "@components/product/ProductHero";
import { MORTGAGE } from "@/lib/site";
import { useTranslations } from "@services/strings";
import Link from "next/link";

const MortgagePage = () => {
  const { t, formatPercent } = useTranslations();
  const vars = {
    ltv: formatPercent(MORTGAGE.maxLoanToValue),
    maxYears: MORTGAGE.maxYears,
    approvalDays: MORTGAGE.approvalDays,
  };

  return (
    <Page
      title={t("site.mortgage.meta.title")}
      description={t("site.mortgage.meta.description", vars)}
    >
      <ProductHero
        placement="mortgage-hero"
        eyebrow={t("site.mortgage.hero.eyebrow")}
        title={t("site.mortgage.hero.title")}
        subtitle={t("site.mortgage.hero.subtitle", vars)}
        facts={(["ltv", "years", "days"] as const).map((id) => ({
          value: t(`site.mortgage.facts.${id}.value`, vars),
          label: t(`site.mortgage.facts.${id}.label`),
        }))}
        cta={
          <Link
            href="#contact-form"
            className="inline-flex h-12 items-center rounded-full bg-ink px-6 text-base font-semibold text-white hover:bg-navy"
          >
            {t("site.mortgage.form.title")}
          </Link>
        }
      />

      <Checklist
        tone="mist"
        columns={1}
        title={t("site.mortgage.fit.title")}
        items={(["resale", "upgrade", "investment"] as const).map((id) =>
          t(`site.mortgage.fit.items.${id}`),
        )}
      />

      <TextBlock
        title={t("site.mortgage.status.title")}
        body={t("site.mortgage.status.body")}
      />

      <FormBlock
        title={t("site.mortgage.form.title")}
        body={t("site.mortgage.form.body")}
        interest="mortgage"
        placement="mortgage"
      />
    </Page>
  );
};

export default MortgagePage;
